import { render, staticRenderFns } from "./ModalInputBase.vue?vue&type=template&id=4881129c&scoped=true&"
import script from "./ModalInputBase.vue?vue&type=script&lang=ts&"
export * from "./ModalInputBase.vue?vue&type=script&lang=ts&"
import style0 from "./ModalInputBase.vue?vue&type=style&index=0&id=4881129c&lang=scss&scoped=true&"
import style1 from "./ModalInputBase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4881129c",
  null
  
)

export default component.exports